"use strict";

var pdfDirectiveCtrl = [
  "$state",
  "Department",
  "$serverData",
  "$rootScope",
  function($state, Department, $serverData, $rootScope) {
    var _this = this;
    _this.PdfCreationEnabled = true;

    $rootScope.$on("generating-pdf", function(event, data) {
      if (data.generatingPdf) {
        _this.PdfCreationEnabled = false;
      } else {
        _this.PdfCreationEnabled = true;
      }
    });

    this.getPDF = function(item) {
      if (!_this.PdfCreationEnabled) {
        return;
      }
      $rootScope.$broadcast("generating-pdf", { generatingPdf: true });
      _this.loading = true;
      return Department.pdf({
        departmentId: $state.params.departmentId,
        formId: item.formId,
        itemId: item.id
      })
        .$promise.then(function(response) {
          _this.loading = false;
          var pdfUrl = response.response;
          window.open($serverData.server + pdfUrl, "_blank");
          $rootScope.$broadcast("generating-pdf", { generatingPdf: false });
          return;
        })
        .catch(function() {
          $rootScope.$broadcast("generating-pdf", { generatingPdf: false });
          _this.loading = false;
          return;
        });
    };
  }
];

module.exports = function() {
  return {
    restrict: "E",
    scope: {
      item: "="
    },
    controller: pdfDirectiveCtrl,
    controllerAs: "ctrl",
    bindToController: true,
    template:
      '<a href ng-click="ctrl.getPDF(ctrl.item); $event.stopPropagation()">PDF</a><i ng-if="ctrl.loading" class="icon ion-load-c pdf-loader"></i>'
  };
};
